

import { Component, Vue, Prop} from 'vue-property-decorator';
import { Question } from "survey-vue";


@Component
export default class TextBeforeInputNumber extends Vue {
    
    @Prop({required: true})
    question!: Question
 
    bodyText = ''
    inputWidth = ''
    textClass = ''
    readOnly = false    

    mounted(){
        this.readOnly = this.question.readOnly;
        this.bodyText = this.question.processedTitle;
        this.inputWidth = this.question.inputWidth;
        this.textClass = this.question.textClass;
    }
}
